<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
  _/                                                                                                                    _/
  _/      子画面定義：ファイルアップロード確認画面(FMUploadConfirm)                                                               _/
  _/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <!-- ポップアップ：アップロード確認 -->
  <!-- <div class="overlay hide" id="popup-upload" data-role="popup-close" data-popup-width="920"> -->
  <div  class="overlay" :class="[isUploadDlgShow ? showClass : hideClass]" id="popup-import" ref="content">
    <div class="popup" style="width: 920px">

      <div class="popup-head">アップロード確認</div>
      <div class="popup-body blue">
        <div class="frm-row">
          <div class="frm-item grow left">
            <!-- ****  メッセージ表示領域 **** -->
            <p class="errMsg title-ico ico-warning" v-show="errors != ''">
              <ErrorMessage :errors="errors"></ErrorMessage>
            </p>
          </div>
        </div>
        <p>ファイルをアップロードします。よろしいですか？</p>
        <ul class="note">
          <li>アップロードするファイルを選択してください。</li>
          <li v-if="agreement == '0'">
            アップロード時にAI-OCRでの読み取りを行う場合は対象の書類の種類を選択してください。AI-OCRの読み取りを行うと、取引年月日、取引先、取引金額を読み取り取引情報の値を自動設定します。</li>
        </ul>
        <div class="frm-row" v-if="agreement == '0'">
          <!-- <div class="frm-row"> -->
          <span class="frm-label w-50px"><strong>AI-OCR</strong></span>
          <div class="frm-toggle frm-size-toggle-2" tabindex="0" @keydown.left.stop.prevent="toggleRadio1"
            @keydown.right.stop.prevent="toggleRadio1" ref="refCollectively">
            <label>
              <input type="radio" id="collect1" :value="true" v-model="collectively" tabindex="-1" />
              <span>一括設定</span>
            </label>

            <label>
              <input type="radio" id="collect2" :value="false" v-model="collectively" tabindex="-1" />
              <span>個別設定</span>
            </label>
          </div>
          <label style="margin-left:50px"></label>
          <div v-if="collectively">
            <div class="frm-toggle frm-size-toggle-5" tabindex="0" @keydown.left.stop.prevent="toggleRadio2(-1)"
              @keydown.right.stop.prevent="toggleRadio2(1)">
              <label v-for="(item, i) in syuruiArray" :key="i">
                <input type="radio" v-bind:name="'rdb' + 0" v-model="this.fileType" :value="i" tabindex="-1" />
                <span>{{ item }}</span>
              </label>
          </div>
        </div>
        </div>

        <!-- {{ this.fileType }}
              {{ this.fileTypeList }}
              {{ this.selectedIndexList }} -->
        <!-- <div class="table-section"> -->

       
          <div class="table-wrap mt-20px">
            <div class="table-scroll-header">
              <table class="table-select single-select">
                <colgroup>
                  <col class="col-1" >
                  <col class="col-2" >
                  <col class="col-3" v-if="!collectively" />
                </colgroup>
                <thead>
                  <tr>
                    <th class="multi-select-item">
                     
                      <label class="frm-checkbox">
                        <input type="checkbox" @click="selectAllRow" :checked="checkAll" />
                        <span class="checkbox-item" tabindex="0" @keydown.space.stop.prevent="selectAllRow">
                        </span>
                      </label>
                    </th>
                    <th class="sort alignleft">対象ファイル
                    </th>
                    <th class="sort alignleft" v-if="!collectively">AI-OCR(書類種別)
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="table-scroll-body h-270px">
              <table class="table-select multi-select-item">
                <colgroup>
                  <col class="col-1" style="background-color: #fff;">
                  <col class="col-2" style="background-color: #fff;">
                  <col class="col-3" style="background-color: #fff;" v-if="!collectively" />
                </colgroup>

                <tbody>
                  <tr v-for="(file, index) in this.uploadFiles" :key="index" :class="{
                    selected: this.selectedIndexList.includes(index)
                  }">
                    <td @click="selectRow(index)" class="aligncenter">
                      <label class="frm-checkbox">
                        <input type="checkbox" v-bind:id="'chk' + index" v-bind:value="index" @change="selectRow(index)"
                          :checked=this.selectedIndexList.includes(index) />

                        <span class="checkbox-item" tabindex="0" @keydown.space.stop.prevent="selectRow(index)">
                        </span>
                      </label>
                    </td>
                    <td @click="selectRow(index)" class="alignleft">
                      <span>{{ file.name }}</span>
                    </td>
                    <td v-if="!collectively" style="padding-right:40px">
                      <div  class="frm-toggle frm-size-m" tabindex="0"
                        @keydown.left.stop.prevent="toggleRadio3(-1, index)"
                        @keydown.right.stop.prevent="toggleRadio3(1, index)">
                        <label v-for="(item, i) in syuruiArray" :key="i">
                          <input tabindex="-1" type="radio" v-bind:name="'rdb' + index" v-model="this.fileTypeList[index]"
                            :value="i" />
                          <span>{{ item }}</span>
                        </label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        <!-- </div> -->
        <div class="storage-status" v-if="userType == '0' && agreement == '0'">
          <!-- <div class="storage-status"> -->
          <span class="storage-label" v-show="agreement">利用項目数：{{ itemsAvailable }}</span>
          <div class="storage-progress">
            <!-- プログレスバーの計算 -->
            <div class="progress">
              <div class="progress-bar gray" :style="('width: ' + this.percentageTotal + '%')"></div>
              <div class="progress-bar blue" :style="('width: ' + this.percentageUsed + '%')"></div>
            </div>
            <ul class="storage-note">
              <li class="gray">利用済み：{{ total }}</li>
              <li class="blue">他ユーザ利用中：{{ used }}</li>
              <li class="sky">利用可能：{{ available }}</li>
            </ul>
          </div>
        </div>
        <div class="frm-btn-row footer-btn">
          <div class="frm-item grow center">
            <button ref="confirmBtn" tabindex="0" class="frm-btn strong large" @click="handleYes"
              :disabled="selectedIndexList.length == 0">
              はい
            </button>
            <button tabindex="0" class="frm-btn large" @click="handleNo" @blur="onblur">
              いいえ
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
  <STFMFM02C18ProcessingModal :isProcessingCompleteShow=STFMFM02C18Modle.isProcessingCompleteShow
    :pfileCount=STFMFM02C18Modle.pfileCount @confirm="confirm" @disagree="disagree" @onsuccessed="handleSuccessed">
  </STFMFM02C18ProcessingModal>
  <STFMFM02C28AddFileComfirm :isComfirmDlgFlagDlgShow=STFMFM02C28Modle.isComfirmDlgFlagDlgShow
    :isUploadFlg=STFMFM02C28Modle.isUploadFlg @confirm="confirm">
  </STFMFM02C28AddFileComfirm>
</template>

<script>
import ErrorMessage from "@/components/ErrorMessage.vue";
import STFMFM02C18ProcessingModal from "@/components/STFMFM02C18ProcessingModal.vue";
import STFMFM02C28AddFileComfirm from "@/components/STFMFM02C28AddFileComfirmModal.vue";
import Common from "@/util/common.js";
import validation from "@/util/validation.js";
import { API_STFMFM02C16_DisplayFileUpload, API_STFMFM02C16_FileUpload, API_STFMFM02C16_initClear } from "@/api/Modules/FM02/STFMFM02C16.js";
import { mapMutations } from "vuex";
export default {
  name: "SFMFileUpload",
  components: {
    ErrorMessage,
    STFMFM02C18ProcessingModal,
    STFMFM02C28AddFileComfirm,
  },
  props: {
    isFileUploadDlgShow: {
      type: Boolean,
      required: true,
    },
    uploadFiles: {
      type: [],
      required: true,
    },
  },
  data() {
    return {
      showClass: "show",
      hideClass: "hide",
      files: [],
      errors: [],
      targetInfo: "",
      infoNameArea: "",
      infoNameAddArea: "",
      collectively: true,
      list: [],
      syuruiArray: ["対象外", "注文書", "領収書", "請求書"],
      syuruiArrayCode: ["", "1", "4", "6"],
      selectedIndexList: [], // 選択Indexリスト

      fileType: "",
      fileTypeList: [],
      rdbCollect: [],
      STFMFM02C18Modle: {},
      STFMFM02C28Modle: {},
      //利用済み進捗パー
      percentageTotal: 0,
      //他ユーザー利用中進捗パー
      percentageUsed: 0,
      //AIOCR読取項目数の契約上限値
      maximum: 0,
      //利用可能項目数
      itemsAvailable: "",
      //利用済み
      total: 0,
      //他ユーザー利用中
      used: 0,
      //全行選択時
      checkAll: true,
      totalCount: 0,
      isUploadDlgShow: false,
      endIsUploadFlg: false,
      uploadMax: 0,
    };
  },
  created() {

  },
  mounted() {
    //this.initialize();
  },
  computed: {
    // **********************************************
    // * ボタン活性、非活性
    // **********************************************
    // isDisabled() {
    //   return this.files.length == 0 ? true : false;
    // },
  },
  watch: {
    isFileUploadDlgShow: function(newVal) {
      this.handleBodyScrollOnModalStateChange(newVal)
    },
    uploadFiles: function (newVal) {
      this.initialize();
      if (newVal.length > 0) {

        this.selectedIndexList = new Array();
        this.fileTypeList = new Array();
        for (let i = 0; i < newVal.length; i++) {
          this.selectedIndexList.push(i);
          this.fileTypeList.push(0);
        }
        this.totalCount = this.selectedIndexList.length;
      }
    },
  },
  methods: {
    ...mapMutations("businessModule", ["handleBodyScrollOnModalStateChange"]),
    // **********************************************
    // 初期表示処理
    // **********************************************
    initialize() {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      //アップロード確認(電子取引)初期表示
      API_STFMFM02C16_DisplayFileUpload(config).then((response) => {
        this.isUploadDlgShow = this.isFileUploadDlgShow;
        this.fileType = 0;
        this.agreement = response.agreement;
        this.$nextTick(function () {
          if (this.agreement == '0' && this.$refs.refCollectively) {
            this.$refs.refCollectively.focus();
          } else {
            this.$refs.confirmBtn.focus();

          }
        });

        if (response.errorCD) {
          //契約無
          if (response.errorCD == "MTFM1220") {
            // エラー表示
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [response.errorName[0]])
              )
            );
          } else if (response.errorCD == "MTFM1230") {
            // ＜利用済みのAIOCR読取項目数＞＋＜他ユーザの利用中AIOCR読取項目数＞＝＜AIOCR読取項目数の契約上限値＞の場合は
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [response.errorName[0]])
              )
            );
            this.userType = response.userType;
            this.agreement = response.agreement;
            this.maximum = response.maximum;
            this.itemsAvailable = response.itemsAvailable;
            this.used = response.used;
            this.total = response.total;
            this.available = response.available;

            this.percentageUsed = _.divide(this.used, this.maximum) * 100;
            this.percentageTotal = _.divide(this.total, this.maximum) * 100;
          } else {
            // エラー表示
            if (response.errorName != null && response.errorName.length > 0) {
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [response.errorName[0]])
                )
              );
            } else {
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                )
              );
            }
          }
        } else {
          this.userType = response.userType;
          this.agreement = response.agreement;
          this.maximum = response.maximum;
          this.itemsAvailable = response.itemsAvailable;
          this.used = response.used;
          this.total = response.total;
          this.available = response.available;
          this.percentageTotal = _.divide(this.total, this.maximum) * 100;
          this.percentageUsed = _.divide(this.used, this.maximum) * 100;
        }

      });

    },
    onblur(e) {
      if (!e) return;
      e.preventDefault();
      const focusable = this.$refs.content.querySelectorAll(
        '[tabindex]:not([tabindex="-1"])'
      );
      // Find and focus the first available element inside the dialog
      const el = [...focusable].find((el) => !el.hasAttribute("disabled"));
      el && el.focus();
    },
    disagree() {
      this.STFMFM02C18Modle.isProcessingCompleteShow = false;
      this.STFMFM02C18Modle.pfileCount = 0;
      //完了画面起動
      this.STFMFM02C28Modle = {
        isComfirmDlgFlagDlgShow: true,
        isUploadFlg: this.endIsUploadFlg,
      }
    },
    // **********************************************
    // * いいえボタンをクリック
    // **********************************************
    handleNo() {
      // 初期化
      this.clearError();
      this.$emit("disagree");
    },
    // **********************************************
    // * はいボタンをクリック
    // **********************************************
    handleYes(e) {
      if (e && e.srcElement) {
        e.srcElement.blur()
      }
      // 初期化
      this.errors = [];
      // インポートボタン 非活性化
      // this.isDisabled = true;

      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      this.uploadMax = 0;
      var countSize = 0;
      let formData = new FormData();
      for (let i = 0; i < this.uploadFiles.length; i++) {
        if (!this.selectedIndexList.includes(i)) {
          continue;
        }
        //入力値チェック
        if (this.checkInputData(this.uploadFiles[i], this.uploadFiles[i].name)) {
          return;
        }

        formData.append("FileInfos", this.uploadFiles[i], this.uploadFiles[i].name);
        if (this.collectively) {
          formData.append("PaperTypeList", this.syuruiArrayCode[this.fileType]);
        } else {
          formData.append("PaperTypeList", this.syuruiArrayCode[this.fileTypeList[i]]);
        }
        countSize += this.uploadFiles[i].size;
        this.uploadMax++;
      }
      //または合計サイズが115MBを超える。
      if (countSize / 1024 / 1024 / 115 > 1) {
        this.setErrMsg("MTFM1510", []);
        return true;
      }
      // 前回処理進捗クリア処理
      API_STFMFM02C16_initClear(this.uploadMax).then((response) => {
        // 正常終了の場合
        if (_.eq(response.result, "0000")) {

        } else {
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }
      });
      //処理中画面起動
      this.STFMFM02C18Modle = {
        isProcessingCompleteShow: true,
        pfileCount: this.uploadMax,
      };

      // API呼出
      API_STFMFM02C16_FileUpload(formData, config) //←実装中なので、下記APIを例として挙げる
        .then((response) => {
          if (_.eq(response.result, "0000")) {
            this.endIsUploadFlg = response.isUploadFlg;
          } else {
            //処理中画面中止
            this.STFMFM02C18Modle.isProcessingCompleteShow = false;
            // エラー表示
            if (response.errorName != null && response.errorName.length > 0) {
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [response.errorName[0]])
                )
              );
            } else {
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                )
              );
            }
          }
        }).catch((err)=>{
          if (err && err.status == 400) {
            this.errors.push(
              Common.createError(
                "MTFM1510",
                Common.getMessage("MTFM1510", [])
              )
            );
            this.STFMFM02C18Modle.isProcessingCompleteShow = false;
          }
        });
    },
    //入力値チェック
    checkInputData(realFiles, fileName) {
      var bRet = true;
      //拡張子が.html、.htmのファイルが含まれる　又はファイルの拡張子が存在しない。
      let file_type = fileName.split('.').pop();
      if (file_type == "html" || file_type == "htm" || file_type == "" || file_type == fileName) {
        this.setErrMsg("MTCL1107", [""]);
        return true;
      }

      // ファイル名に入力禁止文字が使用されている。
      // ※設計書『D - ED005_共通処理設計書.xlsx』参照。  
      if (
        !validation.checkNationalkinsokuchar(fileName) ||
        !validation.CheckFileNameInvalid(fileName)
      ) {
        this.setErrMsg("MTCL1098", ["名称"]);
        return true;
      }

      // 0バイトファイルはエラー
      if (realFiles.size == 0) {
        this.setErrMsg("MTFM1260", []);
        return true;
      }

      // 115Mを超えるファイルはエラー
      if (this.checkFileSize(realFiles.size)) {
        this.setErrMsg("MTFM1510", []);
        return true;
      }

    },
    /* ファイルサイズ(115M)チェック
     * @param {ファイルサイズ} fileSize 
     */
    checkFileSize(fileSize) {
      return fileSize / 1024 / 1024 / 115 > 1 ? true : false
    },

    /**
     * エラー内容セット
     * @param {エラーコード} errCd 
     * @param {エラーコードの埋め込み文字} param 
     */
    setErrMsg(errCd, param) {
      if (this.errors.length == 0) {
        this.errors.push(
          Common.createError(
            errCd,
            Common.getMessage(errCd, param)
          )
        );
      }
    },

    //行選択時の処理
    selectRow(index) {
      if (this.selectedIndexList.includes(index)) {
        let i = this.selectedIndexList.indexOf(index);

        this.selectedIndexList.splice(i, 1);
      } else {
        this.selectedIndexList.push(index);
      }
      var selectCount = this.selectedIndexList.length;
      if (this.totalCount == selectCount) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },

    // 全行選択時の処理
    selectAllRow: function () {
      this.checkAll = !this.checkAll;
      this.selectedIndexList = [];
      var _self = this;
      if (this.checkAll) {
        this.selectedIndexList = [];
        for (var i = 0; i < this.uploadFiles.length; i++) {
          this.selectedIndexList.push(i);
        }
      }
    },

    // **********************************************
    // * エラーメッセージ、ファイルの初期化処理
    // **********************************************
    clearError() {
      this.collectively = true;
      this.checkAll = true;
      this.uploadMax = 0;
      this.files = [];
      this.errors = [];
    },
    handleSuccessed() {
      setTimeout(() => {
        this.STFMFM02C18Modle.isProcessingCompleteShow = false
        this.STFMFM02C28Modle = {
          isComfirmDlgFlagDlgShow: true,
          isUploadFlg: this.endIsUploadFlg,
        }
      }, 2000);

    },
    toggleRadio1() {
      this.collectively = !this.collectively
    },
    toggleRadio2(step) {
      if (this.fileType >= this.syuruiArray.length - 1 && step === 1) {
        this.fileType = 0
      } else if (this.fileType === 0 && step === -1) {
        this.fileType = this.syuruiArray.length - 1
      } else {
        this.fileType = this.fileType + step
      }
    },
    toggleRadio3(step, index) {
      if (this.fileTypeList[index] >= this.syuruiArray.length - 1 && step === 1) {
        this.fileTypeList[index] = 0
      } else if (this.fileTypeList[index] === 0 && step === -1) {
        this.fileTypeList[index] = this.syuruiArray.length - 1
      } else {
        this.fileTypeList[index] = this.fileTypeList[index] + step
      }
    },
  },
};
</script>
<style scoped>
.frm-toggle.frm-size-m{
  width: 100%;
  /* padding-right: 40px; */
}
.col-1{
  width: 40px;
}
.col-2{
  width: auto;
  min-width:300px;
}
.col-3{
  width:300px;
} 
@media (max-width: 768px) {
  .frm-btn-row .frm-item .frm-btn{
    min-width: 160px;
   
  }
  .table-section{
    overflow: hidden;
    padding-bottom: 30px;
  }
  .table-wrap{
    width: 100%;
    overflow-x: auto;
    overflow-y: auto;
    padding-bottom: 40px;
  }
  .table-wrap .table-scroll-body{
    /* overflow: hidden; */
    overflow: unset;
  }
  .col-1{
    width: 40px;
  }
  .col-2{
    min-width: unset;
    width: auto;
  }
  .col-3{
    min-width: unset;
    width: 100px;
  }
  .frm-toggle{
    width: 280px;
  }
  .overlay>.popup>.popup-body.blue{
    padding-right: 10px;
  }
  .frm-btn-row.footer-btn >.frm-item{
    flex-wrap: wrap;
    gap: 10px;
  }
  .frm-btn-row.footer-btn >.frm-item > .frm-btn:last-child{
    margin-left: 0;
  }
}
</style>

